import { InspectionTemplateDraft } from "@/shared/models/Inspection";

export type TemplateModalMode =
	| "create"
	| "revision"
	| "duplicate"
	| "update"
	| "view"
	| "delete";

export type TemplateModalTarget = {
	openedAt: number;
	mode: TemplateModalMode;
	draft: InspectionTemplateDraft;
	sectionName: string;
	inspectionCount: number;
};

export const TEMPLATE_MODAL_TITLES: Record<TemplateModalMode, string> = {
	create: "NEW INSPECTION TEMPLATE",
	revision: "NEW REVISION",
	duplicate: "DUPLICATE INSPECTION TEMPLATE",
	update: "EDIT REVISION",
	view: "REVISION",
	delete: "DELETE REVISION",
};
